<template>
    <div class="settings-index">
        <div class="account">
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left" style="width:20px"> 
                        </th>
                        <th class="text-left">
                            Opis
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in memberOptions" :key="item.key" :id="item.key">
                        <td><v-checkbox v-model="item.value" style="display: inline-flex;"></v-checkbox></td>
                        <td><label>{{ $page.props.lang[item.key] || "Option" }}</label></td>
                        </tr>
                    </tbody>
                    </template>
            </v-simple-table>
            <div class="column button-wrap" style="margin-top:20px;">
                <v-btn @click="saveSettings" color="primary" width="160">
                    {{ $page.props.lang.save || 'Save' }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import SettingsLayout from '@/js/Layouts/SettingsLayout'
import EventBus from '@/js/eventbus'

export default {
    layout: (h, page) => {
      return h(AppLayout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.notifications || "Notifications"
        }
    },
    props: {
        memberOptions: Array
    },
    data() {
        return {
            toReturn: this.memberOptions,
            responseErrors: {}
        }
    },
    methods: {
        saveSettings() {
            var toSubmit = {};
            this.toReturn.forEach(function (item) {
                toSubmit[item.key] = item.value;
            });
            axios.post('/backoffice/settings/saveMemberOptions', {options: toSubmit})
                .then(response => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    });
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        }
    }
}
</script>
